/**
 * WordPress dependencies
 */

export default {
	hookPrefix: 'testimonials',
};
